import $ from 'jquery'

export default {
    name: 'antecedent-enf-personnel',
    components: {},
    props: ["consultation", "activeRole"],

    data() {
        return {
            is_loading: true,
            is_empty: false,

            save_loading: false,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'rang_fratrie', 'deroule_normal', 'pathologie', 'accouchement_terme',
                'accouchement_mode', 'accouchement_reanimation', 'accouchement_poids_naissance',
                'poids_unit', 'etat_vat_pev', 'etat_vat_hors_pev', 'etat_vat_justif',
                'prophylaxie_anti_palustre', 'regime_bien_conduit', 'regime_justif',
                'deparasitage', 'developpement_psycho', 'developpement_psycho_justif',
                'croissance_somatique', 'croissance_justif', 'supplementation_fer',
                'supplementation_acide_folique', 'supplementation_vit', 'atcd_perso_physio_autre',
                'hospitalisation', 'hospitalisation_nombre', 'hospitalisation_derniere_date',
                'transfusion', 'transfusion_nombre', 'transfusion_derniere_date',
                'drepanocytose', 'allergie_medicamenteuse', 'allergie_justif',
                'autre_allergie', 'autre_allergie_mention', 'atopie',
                'atopie_mention', 'hemolyse', 'hemolyse_mention'
            ],

            is_physio: true,

            ij: 0
        }
    },

    computed: {
        antecedent_enf_personnel() {
            return this.$store.getters["antecedent_enf_personnel"];
        },
    },

    mounted() {
        this.listeChampATCDENFpersonnel()
    },

    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_enf_personnel.length > 0) {
                    v = this.antecedent_enf_personnel[index]['field_content']
                } else {
                    if (fld == 'poids_unit') {
                        v = 'Kg'
                    }
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        async listeChampATCDENFpersonnel() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_enf_personnel',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        toggleSection() {
            this.is_physio = (this.is_physio)?false:true
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_enf_personnel',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDENFpersonnel()
                }

                this.save_loading = false
            })
        }
    }
}


